import { openNotification } from '@/helpers/mantine-notification-helper';
import { IBackInStockSubscribe, IProductDetails } from '@/interfaces/product';
import { backInStockSubscribe, backInStockSubscribeAnonymous } from '@/services/product.service';
import { useMutation } from '@tanstack/react-query';
import { getDataLayer } from '@/utils/data-layer';

export const useBackInStock = (product: IProductDetails) => {
  return useMutation({
    mutationFn: backInStockSubscribe,
    onSuccess: (data) => {
      openNotification('success', 'Stock Subscription', data);
      let obj: { [key: string]: string } = {};

      if (product?.CategoryName) {
        let splittedCategories = product?.CategoryName.split(',');
        splittedCategories.forEach((category, categoryIndex) => {
          obj['item_category' + (categoryIndex ? categoryIndex : '')] = category;
        });
      }
      if (!product?.IsGiftVoucher && product?.Gender) {
        obj['gender'] = product?.Gender;
      }
      const itemArray = [
        {
          item_id: product?.SeName,
          item_name: product?.Name,
          item_sku: product?.Sku,
          item_brand: product?.ProductBrand?.Name,
          price: product?.ProductPrice?.Price,
          quantity: product?.StockQuantity,
          item_variant: product?.Variations?.map((variation) => variation?.VariantSku),
          color: product?.AvailableColors?.map((color) => color?.ColorName),
          size: product?.Variations?.map((variation) => variation?.ProductAttributeValue),
          ...obj,
        },
      ];
      const dataLayer = getDataLayer();
      if(dataLayer) {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
          event: 'back_in_notification',
          ecommerce: {
            items: itemArray,
          },
        });
      }
    },
    onError: (data: any) => {
      openNotification('danger', 'Stock Subscription', data);
    },
  });
};
export const useBackInStockAnonymous = (product: IProductDetails, captchaResponse?: string) => {
  return useMutation({
    mutationFn: (backInStockAnonymousProduct: IBackInStockSubscribe) => {
      return backInStockSubscribeAnonymous(backInStockAnonymousProduct, captchaResponse);
    },
    onSuccess: (data) => {
      openNotification('success', 'Stock Subscription', data);
      let obj: { [key: string]: string } = {};

      if (product?.CategoryName) {
        let splittedCategories = product?.CategoryName.split(',');
        splittedCategories.forEach((category, categoryIndex) => {
          obj['item_category' + (categoryIndex ? categoryIndex : '')] = category;
        });
      }
      if (!product?.IsGiftVoucher && product?.Gender) {
        obj['gender'] = product?.Gender;
      }
      const itemArray = [
        {
          item_id: product?.SeName,
          item_name: product?.Name,
          item_sku: product?.Sku,
          item_brand: product?.ProductBrand?.Name,
          price: product?.ProductPrice?.Price,
          quantity: product?.StockQuantity,
          item_variant: product?.Variations?.map((variation) => variation?.VariantSku),
          color: product?.AvailableColors?.map((color) => color?.ColorName),
          size: product?.Variations?.map((variation) => variation?.ProductAttributeValue),
          ...obj,
        },
      ];
      const dataLayer = getDataLayer();
      if(dataLayer) { 
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: 'back_in_notification',
        ecommerce: {
          items: itemArray,
        },
      });
      }
    },
    onError: (data: any) => {
      openNotification('danger', 'Stock Subscription', data);
    },
  });
};
